import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import "react-toastify/dist/ReactToastify.css";
import store from "./store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { ModalProvider } from "./components/ContextApi/modal/modalContext";
import ModalRoot from "./components/ContextApi/modal/modalRoot";
// import "react-phone-input-2/lib/style.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ToastContainer />
    <BrowserRouter>
      <ModalProvider>
        <App />
        <ModalRoot />
      </ModalProvider>
      <ScrollToTop />
    </BrowserRouter>
  </Provider>,
);
